import { useApi } from "../../../swr/useApi";
import { adminChangeRequestsService } from "../../api_client";
import type { ChangeRequestsResponseDto } from "../../../api";
import { ChangeRequestDtoTypeEnum } from "../../../api";

export function useUserBankingChangeRequests(userId: string | undefined) {
  const { data, isLoading } = useApi<ChangeRequestsResponseDto>(
    userId ? `user-banking-crs-${userId}` : null,
    () => adminChangeRequestsService.adminListChangeRequests({ userId, page: 1, pageSize: 50 }),
  );

  const bankingRequests = (data?.data ?? []).filter(
    (cr) => cr.type === ChangeRequestDtoTypeEnum.BankAccountCreate,
  );

  return { bankingRequests, isLoading };
}
